import React, { useState } from "react";

import { TextField } from "@mui/material";

const FieldStyle = {
  borderRadius: "3px",
};

const InputLabelPropsStyle = {
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#00000075",
};

// normal textfield with some default props
const CustomTextField = ({
  label,
  name,
  type,
  validation,
  classes = "",
  otherProps,
  disabled = false,
  InputProps,
  multiline = false,
  placeholder = null,
  shrink = false,
  // Opt-in only: empty fields use centered placeholder instead of floating label.
  centeredEmptyPlaceholder = false,
}) => {
  const {
    onChange: otherOnChange,
    onFocus: otherOnFocus,
    onBlur: otherOnBlur,
    ...restOtherProps
  } = otherProps || {};

  const [focused, setFocused] = useState(false);
  const hasStartAdornment = Boolean(InputProps?.startAdornment);
  const rawValue = validation?.values?.[name];
  const hasValue =
    rawValue !== "" && rawValue !== null && rawValue !== undefined;

  const hideLabelWhileEmpty =
    centeredEmptyPlaceholder &&
    !multiline &&
    !hasStartAdornment &&
    !hasValue &&
    !focused &&
    type !== "date";

  // $-prefixed fields: empty = placeholder beside $; focus/value = floating name tag
  const showNameTag =
    type === "date" ||
    hasValue ||
    focused ||
    (!hasStartAdornment && shrink);

  const shouldShrinkLabel = hideLabelWhileEmpty ? false : Boolean(showNameTag);

  const inlinePlaceholder = placeholder ?? label;
  const effectivePlaceholder = hasStartAdornment
    ? placeholder || label
    : hideLabelWhileEmpty
      ? inlinePlaceholder
      : placeholder;

  return (
    <>
      <TextField
        className={`sign-textField ${classes}${
          hasStartAdornment ? " sign-textField--currency" : ""
        }`}
        label={
          hasStartAdornment && !showNameTag
            ? undefined
            : hideLabelWhileEmpty
              ? undefined
              : label
        }
        name={name}
        id={name}
        multiline={multiline}
        type={type || "text"}
        value={rawValue ?? ""}
        variant="outlined"
        sx={FieldStyle}
        InputLabelProps={{
          style: InputLabelPropsStyle,
          shrink: shouldShrinkLabel,
        }}
        onChange={(event) => {
          validation?.setFieldValue(name, event.target.value);
          otherOnChange?.(event);
        }}
        onFocus={(event) => {
          setFocused(true);
          otherOnFocus?.(event);
        }}
        onBlur={(event) => {
          setFocused(false);
          otherOnBlur?.(event);
        }}
        helperText={validation?.touched?.[name] && validation?.errors?.[name]}
        error={
          validation?.touched?.[name] && Boolean(validation?.errors?.[name])
        }
        disabled={disabled}
        InputProps={InputProps}
        placeholder={
          hasStartAdornment || hideLabelWhileEmpty
            ? effectivePlaceholder
            : placeholder
        }
        {...restOtherProps}
      />
    </>
  );
};

export default CustomTextField;
